import { BasicService } from "@/services/basic";
import { createGetUrlWithOptions } from "@/helpers/services";
export class Adjustments extends BasicService {
    constructor(axios) {
        super(axios);
        this.baseURL = "attendance-adjustments";
    }
    async get(options) {
        try {
            const url = createGetUrlWithOptions(this.baseURL, options);
            const { data } = await this.$get(url);
            return Promise.resolve(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async add(adjustment) {
        try {
            await this.$post(this.baseURL, adjustment);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async edit(adjustment) {
        try {
            await this.$put(`${this.baseURL}/${adjustment.id}`, adjustment);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async delete(adjustmentId) {
        try {
            await this.$delete(`${this.baseURL}/${adjustmentId}`);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
